var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_952_143908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 16.2C15.9 15.5 16.9 15 18 15C20.2 15 22 16.8 22 19C22 21.2 20.2 23 18 23C15.8 23 14 21.2 14 19C14 18.8 14.025 18.625 14.05 18.45C14.075 18.275 14.1 18.1 14.1 17.9L8.8 14.8C8.1 15.5 7.1 16 6 16C3.8 16 2 14.2 2 12C2 9.8 3.8 8 6 8C7.1 8 8.1 8.5 8.8 9.2L14.2 6.1C14.1828 6.03137 14.1657 5.96569 14.149 5.90194C14.0686 5.59411 14 5.33137 14 5C14 2.8 15.8 1 18 1C20.2 1 22 2.8 22 5C22 7.2 20.2 9 18 9C16.9 9 15.9 8.5 15.1 7.8L9.8 10.9C9.81716 10.9686 9.83431 11.0343 9.85097 11.0981C9.93137 11.4059 10 11.6686 10 12C10 12.2 9.975 12.375 9.95 12.55L9.95 12.55C9.925 12.725 9.9 12.9 9.9 13.1L15.2 16.2ZM20 5C20 3.9 19.1 3 18 3C16.9 3 16 3.9 16 5C16 6.1 16.9 7 18 7C19.1 7 20 6.1 20 5ZM6 14C4.9 14 4 13.1 4 12C4 10.9 4.9 10 6 10C7.1 10 8 10.9 8 12C8 13.1 7.1 14 6 14ZM16 19C16 20.1 16.9 21 18 21C19.1 21 20 20.1 20 19C20 17.9 19.1 17 18 17C17.3 17 16.6 17.4 16.3 18C16.1 18.3 16 18.6 16 19Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_952_143908)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#5E5873"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.906a361eee19e20108d6963cc04a7135.svg";
export { ForwardRef as ReactComponent };